import type { Movie, Person, Show } from '@src/lib/graphql/generated';
import { getSeasonCount } from 'pages/serien/[slug]';

interface StructuredDataProps {
  entry: Movie | Show;
  image: string;
  actors: Person[];
}

export const StructuredData = ({ entry, image, actors }: StructuredDataProps) => {
  const date = entry?.year ? new Date(entry.year, 0).toISOString() : ''; // ! Currently video upload data is not available so it's set to the first day of the year

  const review = {
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: entry.tvm_score,
    },
    author: {
      '@type': 'Organization',
      name: 'TV-MEDIA',
    },
  };

  const aggregateRating = {
    '@type': 'AggregateRating',
    ratingValue: Math.floor(5 * (entry.tmdb_score / 100)),
    ratingCount: 100, // !! Currently don't have the number of ratings
  };

  const trailer = {
    '@type': 'VideoObject',
    contentUrl: `https://www.youtube.com/watch?v=${entry?.youtube}`,
    thumbnailUrl: `https://img.youtube.com/vi/${entry?.youtube}/hqdefault.jpg`,
    name: `${entry?.title} Trailer`,
    description: entry?.summary,
    uploadDate: date,
  };

  const seriesSchema =
    entry.__typename === 'Show'
      ? {
          numberOfSeasons: getSeasonCount(entry?.seasons),
        }
      : {};

  const schema = {
    '@context': 'https://schema.org',
    '@type': entry?.__typename === 'Movie' ? 'Movie' : 'TVSeries',
    name: entry.title,
    abstract: entry.summary,
    ...(image ? { image } : {}),
    ...seriesSchema,
    ...(actors
      ? {
          actor: actors.map((actor) => ({
            '@type': 'Person',
            name: actor.name,
          })),
        }
      : {}),
    ...(entry?.tvm_score ? { review } : {}),
    ...(entry?.tmdb_score ? { aggregateRating } : {}),
    ...(entry?.youtube?.length > 0 ? { trailer } : {}),
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
};
